<template>
  <div class="scroll-section">
    <div class="bg-gradient"></div>
    <div class="container">
      <div class="columns is-6">
        <div class="column is-half is-offset-half">
          <div class="bg-wrapper">
            <div class="mr-bot-bg" :style="'background-image: url('+mr_bot_bg+');'"></div>
          </div>
          <header class="rtm-header animate">
            <h1>
              <strong>{{ $t('ready.heading') }}</strong>
            </h1>
            <h3>{{ $t('ready.sub_heading') }}</h3>
          </header>
          <div class="rtm-copy animate" v-html="$t('ready.paragraph')"></div>
          <ul class="contact-methods animate" style="pointer-events:all;z-index:20000;">
            <li style="">
              <img class="contact-icon" :src="icons.chat">
              <p style="">
                <a style="" href="#" @click.prevent="openChat">{{ $t('ready.chat_txt') }}</a>
              </p>
            </li>
            <li style="">
              <img class="contact-icon" :src="icons.phone">
              <p>{{ $t('ready.phone_txt') }}
                <a href="tel:+4566118311">(+45) 6611 8311</a>
              </p>
            </li>
            <li style="">
              <img class="contact-icon" :src="icons.mail">
              <p>{{ $t('ready.em_txt') }}
                <a href="mailto:info@onlinecity.io">info@onlinecity.io</a>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import iconChat from '../.././assets/icon-chat.svg'
import iconPhone from '../.././assets/icon-phone.svg'
import iconMail from '../.././assets/icon-mail.svg'
import mrBotBg from '../.././assets/mr-bot-static-sm-optimized.png'
import {mapGetters, mapActions} from 'vuex'
import {isElementVisible} from '../../useElementVisible.js'

export default {
  name: 'Ready',
  data() {
    return {
      exclude_from_nav: false,
      nav_title: 'contact_us',
      mr_bot_bg: mrBotBg,
      icons: {
        chat: iconChat,
        phone: iconPhone,
        mail: iconMail
      },
      animationsDone: false,
      animationsInit: false
    }
  },
  mounted() {
    this.hideElements()

    isElementVisible(this.$el, () => {
      this.runSectionAnimations()
    }).attachDefaultEvents()

  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
        }
      }
    },
    scroll_pos(val) {
      if (this.scroll_pos > (this.$el.offsetTop - 200) && this.scroll_pos < ((this.elHeight - 200) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },
  methods: {
    ...mapActions([
      'setActiveSection'
    ]),
    openChat() {
      window.app.openChat()
    },
    hideElements() {
      if (window.ieLegacy()) {
        return
      }
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
      let bg = this.$el.querySelector('.bg-wrapper')
      TweenMax.set(bg, {
        autoAlpha: 0
      })
    },
    runSectionAnimations() {
      if (this.animationsInit) return
      if (window.ieLegacy()) {
        return
      }

      let elements = this.$el.querySelectorAll('.animate')

      TweenMax.staggerTo(elements, 0.5, {
        autoAlpha: 1
      }, 0.2)
      TweenMax.staggerFromTo(elements, 1.8, {
        x: 300
      }, {
        x: 0,
        ease: Power3.easeInOut
      }, 0.1)
      let bg = this.$el.querySelector('.bg-wrapper')
      TweenMax.to(bg, 0.5, {
        autoAlpha: 1,
        delay: 0.7
      })
      TweenMax.fromTo(bg, 2, {
        x: 500
      }, {
        x: 0,
        ease: Power3.easeInOut
      })
      this.animationsInit = true
    }
  }
}
</script>

<style lang="postcss">
.bg-gradient {
  background: ease-out-sine-gradient(
    #d5edef,
    transparent
  );
}
</style>

<style lang="scss" scoped>
.scroll-section {
  padding-top: 110px;
  padding-bottom: 320px;
  background-color: #a1bed4;
  position: relative;
  z-index: 2;
  overflow: hidden;
  @media screen and (max-width: 480px) {
    padding: 0 1.5rem;
    padding-top: 60%;
    padding-bottom: 14%;
  }
}

.bg-gradient {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}

.column {
  position: relative;
  z-index: 2;
}
</style>

<style lang="scss">
.bg-wrapper {
  width: 814px;
  position: absolute;
  z-index: 2;
  right: 62%;
  top: -50px;
  @media screen and (max-width: 1100px) {
    width: 540px;
    right: 80%;
    top: 100px;
  }
  @media screen and (max-width: 768px) {
    top: 110%;
    left: 25%;
    width: 50%;
  }
  @media screen and (max-width: 480px) {
    top: -45%;
    left: 15%;
    width: 70%;
  }
}

.mr-bot-bg {
  width: 100%;
  padding-bottom: 88.94%;
  background-size: 100%;
  position: absolute;
}

.rtm-header {
  position: relative;
  margin-bottom: 2rem;
  z-index: 1;

  > h1 {
    color: #343434;
    text-transform: uppercase;
    font-size: 3rem;

    strong {
      color: #343434;
    }
  }

  > h3 {
    display: inline-block;
    position: absolute;
    right: 44px;
    bottom: -40px;
    font-family: 'angelique_roseregular';
    font-size: 3rem;
    color: #ff7c4e;
  }

  @media screen and (max-width: 768px) {
    h1 {
      font-size: 1.9rem;
    }
    h3 {
      font-size: 2.5rem;
      bottom: -35px;
    }
  }
}

.rtm-copy {
  position: relative;
  z-index: 1;
  margin-bottom: 2rem;

  > p {
    color: #343434;
    font-size: 1.1rem;
    line-height: 1.8rem;
  }
}

.contact-methods {
  position: relative;
  z-index: 1;

  > li {
    font-size: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 1rem;
    @media screen and (max-width: 768px) {
      margin-bottom: .7rem;
      font-size: 1.2rem;
    }

    a {
      color: #58595b;

      &:hover {
        color: #58595b;
        text-decoration: underline;
      }
    }
  }
}

.contact-icon {
  width: 34px;
  margin-right: 1rem;
  @media screen and (max-width: 768px) {
    width: 24px;
    margin-right: .6rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/sections/Ready.vue